import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { Language } from '~/interfaces/Language';

interface FileMessageAttachment {
  id: number;
  original_file_name: string;
  attachment_type: string;
  file_type: string;
  url: string;
  upload_finished_at: string;
  uploaded_by: string;
  user_full_name: string;
  user_type: number;
}

export type MessageSenderType = 'reporter' | 'case_manager' | 'rfi_recipient';

export interface MessageObject {
  id: string;
  from_user: number;
  to_user: number;
  message: string;
  is_read: boolean;
  is_sent: boolean;
  is_translatable: boolean;
  untranslated_message: string;
  is_pre_translated: boolean;
  created_at: string;
  detected_language_ids: number[];
  detected_languages: Array<Language>;
  files: FileMessageAttachment[];
  sender_type?: MessageSenderType;
}

export const applyMarkAsRead = (
  messages: Array<{ from_user: number; is_read: boolean }>,
  readByUserId: number,
) => {
  for (const message of messages) {
    if (message.from_user !== readByUserId) {
      message.is_read = true;
    }
  }
};

export type ReportDataState = {
  messages: {
    conversation: string;
    messages: MessageObject[];
    is_translatable: boolean;
  };
};

const initialState: ReportDataState = {
  messages: {
    conversation: '',
    messages: [],
    is_translatable: false,
  },
};

/* will only be used for report messaging data for reports 
  - messages
  - rfiMessages
*/
const reportDataSlice = createSlice({
  name: 'reportData',
  initialState,
  reducers: {
    setConversation: (state, action: PayloadAction<string>) => {
      state.messages.conversation = action.payload;
    },
    setMessages: (state, action: PayloadAction<MessageObject[]>) => {
      state.messages.messages = action.payload;
    },
    setIsTranslatable: (state, action: PayloadAction<boolean>) => {
      state.messages.is_translatable = action.payload;
    },
    markMessagesAsRead: (
      state,
      action: PayloadAction<{ readByUserId: number }>,
    ) => {
      applyMarkAsRead(state.messages.messages, action.payload.readByUserId);
    },
  },
});

export const {
  setConversation,
  setMessages,
  setIsTranslatable,
  markMessagesAsRead,
} = reportDataSlice.actions;

export default reportDataSlice.reducer;
